<template>
  <!-- DOWNLOAD PDF -->
  <div id="tst">
    <!-- :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'" -->
    <a id="dLinkPdf">
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          :disabled="disableButton"
          :class="[disableButton ? 'c_disabled' : '']"
          color="light-blue darken-4"
          icon
          small
          flat
          @click="setDanfe()"
        >
          <!-- <span dark style="color: white"><span v-if="component.name != 'CTE'">DANFE</span><span v-else>DACTE</span></span> -->
          <svg class="customIcon i_action" viewBox="0 0 24 24">
            <path
              fill="#000000"
              d="M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z"
            />
          </svg>
        </v-btn>
        <span>
          Baixar
          <span v-if="component.name.indexOf('NFe') != -1">DANFE</span>

          <span
            v-else-if="disableButton && !pathPdfMotor"
          >de PDF ainda não disponível, Motor Fiscal está trabalhando nisso!</span>
          <span
              v-else-if="disableButton && pathPdfMotor"
            >de PDF padrão Motor Fiscal ainda não disponível, Motor Fiscal está trabalhando nisso!</span>
          <span v-else-if="!pathPdfMotor">PDF</span>
          <span v-else>PDF Padrão Motor Fiscal</span>
        </span>
      </v-tooltip>
    </a>
  </div>
</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import CteService from "@/domain/notas/cte/CteService";
import NfseService from "@/domain/notas/nfse/NfseService";
export default {
  components: {},
  props: ["nota", "component","pathPdfMotor"],
  data: () => ({
    danfe: ""
  }),
  updated: function() {
    this.$nextTick(function() {});
  },
  computed: {
    disableButton: function() {

      if (this.component.name.toLowerCase().indexOf("nfse") != -1 && this.pathPdfMotor) {
        return !this.nota.item.pathPdfMotor;
      }
      if(this.component.name.toLowerCase().indexOf("nfse") != -1 && !this.pathPdfMotor) {
        return !this.nota.item.pathPdf;
      }

      if(this.component.name.toLowerCase().indexOf("nfe") != -1) {
        if(this.nota.item.docZip !== undefined && this.nota.item.docZip.length) {
          return false;
        }else {
          return true;
        }
      }

    }
  },
  watch: {},
  methods: {
    setDanfe: async function() {
      if (this.component.name.indexOf("NFe") != -1) {
        this.service = new NfeService(this.$http);
        await this.service.getDanfe(this.nota.item._id).then(danfe => {
          this.danfe = danfe;
        });
        this.setDownload();
      } else if (this.component.name.indexOf("CTE") != -1) {
        this.service = new CteService(this.$http);
        await this.service
          .getDacte(this.nota.item._id)
          .then(danfe => (this.danfe = danfe));
        this.setDownload();
      } else if (this.component.name.toLowerCase().indexOf("nfse") != -1) {
        this.service = new NfseService(this.$http);
        await this.service
          .getPdfById(this.nota.item._id, !this.pathPdfMotor )
          .then(danfe => (this.danfe = danfe));
        this.setDownload();
      }
    },
    setDownload: function() {
      var a = document.querySelector("#dLinkPdf");
      a.setAttribute(
        "href",
        "data:application/pdf;base64," + encodeURIComponent(this.danfe)
      );
      const nome = this.nota.item.chave
        ? this.nota.item.chave
        : this.nota.item.numeroNfe;
      a.setAttribute("download", nome + ".pdf");
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    }
  }
};
</script>
<style scoped>
#content {
  display: inline-block;
  z-index: 2;
}
a {
  text-decoration: none;
  margin-top: 3px;
}
#ico {
  color: grey !important;
  transition: color 1 linear;
}
#ico:hover {
  color: #01579b !important;
}
.v-btn {
  margin: 2px 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnDownload/btnPdf/BtnPdf.vue